import Particle from "./Particles";
import WizardStyleWrapper from "./Wizard.style";
import StepWizardCom from "../stepWizard/StepWizardCom";

const Upcoming = () => {
  return (
    <WizardStyleWrapper>
      <Particle />
      <div className="container-fluid" style={{ marginTop: "100px" }}>
        <StepWizardCom />
      </div>
    </WizardStyleWrapper>
  );
};

export default Upcoming;
